module.exports = __webpack_public_path__ + "github-1-dd3b3e265bc4b3772041f9edb8df0292.webp";